/**
 * Centralized screen names and route segments for nav and card/chart views.
 * Use these instead of string literals for paths and screen titles.
 */

/** Route segment (path without leading slash). Used in Sidebar links and router paths. */
export const ROUTE_SEGMENTS = {
  EXECUTIVE_SUMMARY: "executivesummary",
  CHANNEL_DETAIL: "channeldetail",
  SPARX_CATALOG: "sparxscatalog",
  SPARXS_EDITOR: "sparxseditor",
  SVG_ALTERATION: "svgalteration",
} as const;

/** Full route path for createBrowserRouter. */
export const ROUTE_PATHS = {
  HOME: "/",
  EXECUTIVE_SUMMARY: "/executivesummary",
  CHANNEL_DETAIL: "/channeldetail",
  SPARX_CATALOG: "/sparxscatalog",
  SPARXS_EDITOR: "/sparxseditor",
  SPARXS_EDITOR_BY_ID: "/sparxseditor/:id",
  SVG_ALTERATION: "/svgalteration",
  SPARXS_EDITOR_BY_ID_PANEL: "/sparxseditor/:id/:panel",
} as const;

/** Single source of truth for sidebar nav: display name + segment. */
export const NAV_ITEMS = {
  EXECUTIVE_SUMMARY: {
    name: "Executive Summary" as const,
    segment: ROUTE_SEGMENTS.EXECUTIVE_SUMMARY,
  },
  CHANNEL_DETAIL: {
    name: "Channel Detail" as const,
    segment: ROUTE_SEGMENTS.CHANNEL_DETAIL,
  },
  SPARX_CATALOG: {
    name: "Sparxs Catalog" as const,
    segment: ROUTE_SEGMENTS.SPARX_CATALOG,
  },
  SPARXS_EDITOR: {
    name: "Sparxs Editor" as const,
    segment: ROUTE_SEGMENTS.SPARXS_EDITOR,
  },
  SVG_ALTERATION: {
    name: "SVG Alteration" as const,
    segment: ROUTE_SEGMENTS.SVG_ALTERATION,
  },
} as const;

export type NavItemSegment =
  (typeof NAV_ITEMS)[keyof typeof NAV_ITEMS]["segment"];

/** Ordered list for Sidebar iteration (preserves display order). */
export const NAV_ITEMS_LIST = [
  NAV_ITEMS.EXECUTIVE_SUMMARY,
  NAV_ITEMS.CHANNEL_DETAIL,
  NAV_ITEMS.SPARX_CATALOG,
  NAV_ITEMS.SPARXS_EDITOR,
  NAV_ITEMS.SVG_ALTERATION,
] as const;
